export default __webpack_public_path__ + "static/media/MetricsLandingPage.451da0b9.jpg";